/**
 * @description: 请求方法
 */
export enum RequestEnum {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

/**
 * @description:  常用的contentTyp类型
 */
export enum ContentTypeEnum {
  // json
  JSON = 'application/json;charset=UTF-8',
  // json
  TEXT = 'text/plain;charset=UTF-8',
  // form-data 一般配合qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  上传
  FORM_DATA = 'multipart/form-data;charset=UTF-8',
}

/**
 * @description: 请求结果集
 */
export enum ResultEnum {
  SUCCESS = 20000,

  // 跳403页面：
  // FORBIDDEN = 40003,
  // 跨项目
  NO_PROJECT = 570006,
  // 没有权限
  NO_PERMISSION = 570109,

  // 身份过期 需重试token
  EXPIRED_REFRESH = 570001,
  // 身份过期 跳转login
  EXPIRED = 570011,

  // 账号封禁
  DISABLED = 570110,
  // EXPIRED = 100001,
  ERROR = -1,
}
